import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  withStyles, Grid, Container, Box, withTheme,
} from '@material-ui/core';
import MailTemplateCard from './MailTemplateCard';

// #region css
const styles = (theme) => ({
  root: {
    marginBottom: theme.spacing(10),
  },
  cardTitle: {
    backgroundColor: 'rgba(0, 0, 0, 0.38);',
  },
  textCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  emptyTemplates: {
    textAlign: 'center',
  },
  smallTextFieldDate: {
    width: '10ch',
    [theme.breakpoints.down('xs')]: {
      width: '70px',
    },
  },
  gridContainer: {
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
    },
  },
  gridItem: {
    miniHeight: '100px',
    [theme.breakpoints.down('xs')]: {
      marginRight: '20px',
      marginBottom: '20px',
    },
  },
});
// #endregion

class MailTemplateSelector extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
    this.state = { isXs: false };
  }

  componentDidMount() {
    this.updateWidth();
    window.addEventListener('resize', this.updateWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWidth);
  }

  updateWidth = () => {
    const { theme } = this.props;
    this.setState({
      isXs: window.innerWidth < theme.breakpoints.values.sm,
    });
  };

  render() {
    const {
      classes,
      selected,
      datas,
      onSelectTemplate,
    } = this.props;

    const {
      isXs,
    } = this.state;

    return (
      <Container>
        {datas.length > 0 ? (
          <Grid className={classes.gridContainer} container spacing={3}>
            {datas.map((data) => {
              const isSelected = selected?.id === data?.id;
              return (
                <Grid className={classes.girdItem} item xs={isXs ? 12 : 4} mb={4}>
                  <MailTemplateCard
                    data={data}
                    checked={isSelected}
                    onSelectTemplate={onSelectTemplate}
                  />
                </Grid>
              );
            })}
          </Grid>
        ) : (
          <Box className={classes.emptyTemplates}>テンプレートがありません</Box>
        )}
      </Container>
    );
  }
}

export default withStyles(styles)(withRouter(withTheme(MailTemplateSelector)));
